// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__2-Fm9","title":"login_title__1gPww","buttons":"login_buttons__1zKoK","register":"login_register__1jlVz","logout":"login_logout__1DbZx"};